type Props = {
  enabled: boolean;
  onToggle: () => void;
};

/**
 * Discreet per-device switch for the KDS tab, parked on the hamburger menu's version line rather
 * than among the ordinary menu items: it is a device setup detail, not something staff need daily.
 */
const KdsNavToggle = ({ enabled, onToggle }: Props) => (
  <div className="flex justify-end min-w-full px-2 pr-4 pt-2">
    <button
      className="text-sm text-grey-dark underline"
      title="Show or hide the KDS tab on this device"
      onClick={onToggle}
    >
      {enabled ? 'Hide KDS tab' : 'Show KDS tab'}
    </button>
  </div>
);

export default KdsNavToggle;
